module.exports = __webpack_public_path__ + "static/case_02-e403f022cea7ad1509b2ef85af30d7a2.jpg";